// extracted by mini-css-extract-plugin
export default {"mobile_menu__input":"MobileMenuItem_mobile_menu__input__q98oK","mobile_menu__label":"MobileMenuItem_mobile_menu__label__ObbGH"};